import React from 'react'

const ServicesPage = () => {
    return (
        <div style={{color:'rgba(255,255,255)'}}>ServicesPage</div>
    )
}
export default ServicesPage
